import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export const projects = () => {

	let el = document.querySelector('[data-animation="projects-carousel"]')

	if (!el) return

	el.style.opacity = 1

	let width = el.offsetWidth

	gsap.fromTo(el, {
		x: 0,
	}, {
		x: width * -1,
		pin: true,
		ease: 'none',
		scrollTrigger: {
			trigger: el.parentElement.parentElement,
			start: 'center center',
			end: "+=200%",
			scrub: true,
			pin: true,
			// markers: true,
		}
	})

}

export default () => { }